import React from 'react'

const TriageUrlContext = React.createContext("")

export const TriageUrlProvider = TriageUrlContext.Provider
export const TriageUrlConsumer = TriageUrlContext.Consumer
export default TriageUrlContext